module.exports = __webpack_public_path__ + "img/arch-4.8e136f76.svg";